import contractStageApi from '@/api/contractStage'

export const SET_STAGES = 'SET_STAGES'
export const CLEAR_STAGES = 'CLEAR_STAGES'

const state = {
  stages: []
}
const getters = {
  getterContractStages: state => state.stages
}
const mutations = {
  [SET_STAGES] (state, values) {
    state.stages = values
  },
  [CLEAR_STAGES] (state, values) {
    state.stages = []
  }
}
const actions = {
  actionGetContractStages ({ commit }) {
    return contractStageApi.getContractStages()
      .then((response) => {
        commit(SET_STAGES, response.data)

        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.status === 401 ? e.data.error : e.data)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
